import { render, staticRenderFns } from "./IpdokCollection.vue?vue&type=template&id=005bf0c4&"
import script from "./IpdokCollection.vue?vue&type=script&lang=js&"
export * from "./IpdokCollection.vue?vue&type=script&lang=js&"
import style0 from "./IpdokCollection.vue?vue&type=style&index=0&scopes=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports